import React from 'react';
import { Box, Drawer, Stack, Typography } from '@mui/material';
import { useSamplesDrawerOpen } from '../../documents/editor/EditorContext';
//import SidebarButton from './SidebarButton';
//import logo from './waypoint.svg';
import SidebarCopyPaste from './SidebarCopyPaste';
import { useGlobal } from '../../Packages/GlobalContext';
export const SAMPLES_DRAWER_WIDTH = 240;
export default function SamplesDrawer() {
    const samplesDrawerOpen = useSamplesDrawerOpen();
    const { globalState, setGlobalState } = useGlobal();
    // globalState.tags.map()
    const tagButtons = Object.entries(globalState.tags).map(([key, value], index) => (React.createElement(SidebarCopyPaste, { key: index, href: "#", "data-value": value }, key)));
    return (React.createElement(Drawer, { variant: "persistent", anchor: "left", open: samplesDrawerOpen, sx: {
            width: samplesDrawerOpen ? SAMPLES_DRAWER_WIDTH : 0,
        } },
        React.createElement(Stack, { spacing: 3, py: 1, px: 2, width: SAMPLES_DRAWER_WIDTH, justifyContent: "space-between", height: "100%" },
            React.createElement(Stack, { spacing: 2, sx: { '& .MuiButtonBase-root': { width: '100%', justifyContent: 'flex-start' } } },
                React.createElement(Typography, { variant: "h6", component: "h1", sx: { p: 0.75 } }, "Template Tags"),
                React.createElement(Typography, { variant: "body2", color: "text.secondary", paragraph: true }, "A list of tags that can be used within this template. To use a tag, copy and paste the tag into the content of your template text."),
                React.createElement(Stack, { alignItems: "flex-start" }, tagButtons)),
            React.createElement(Stack, { spacing: 2, px: 0.75, py: 3 },
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "overline", gutterBottom: true }, "SMART Platform"),
                    React.createElement(Typography, { variant: "body2", color: "text.secondary", paragraph: true }, "The Email Builder is part for the SMART Platforms library to tools."))))));
}
//# sourceMappingURL=index.js.map